import React, {Component} from "react"
import {Col} from "@irati/ui/src/Layout"
import styled from "styled-components"

import authentication from "@irati/auth"
import {Reward} from "@irati/types"
import {Body} from "@irati/ui/src/Typography"
import {FormattedMessage} from "@irati/utils/lang"
import PopularRewardsQuery, {PopularRewardsData} from "@irati/reward/apollo/query/PopularRewards"

import Search from "../Search"
import PopularReward from "./PopularReward"

const StyledDiv = styled.div`
  display: flex;
  flex-basis: 0;
  flex-wrap: wrap;
`

interface Props {
  onChange: (reward?: Reward, custom?: string) => void
}

class RewardSelect extends Component<Props> {
  render() {
    const {onChange} = this.props
    const tenant = authentication.userTenant()

    return (
      <>
        <Search onChange={onChange} />
        <Col xs={12}>
          <Body small marginBottom={1}>
            <FormattedMessage id="recognition.reward.picker.popularRewards" values={{tenantName: tenant.public_name}} />
          </Body>
          <StyledDiv>
            <PopularRewardsQuery>
              {({data: {popularRewards}}: PopularRewardsData) =>
                popularRewards[0].rewards.map((reward: Reward) => (
                  <PopularReward key={reward.uuid} onClick={() => onChange(reward)} thumbnailImage={reward.thumbnailImage} />
                ))
              }
            </PopularRewardsQuery>
          </StyledDiv>
        </Col>
      </>
    )
  }
}

export default RewardSelect
